import i18n from 'i18n';
import * as Yup from 'yup';

import { ConnectionType, ConnectorsFieldName } from 'pages/Connectors/types';

export const createConnectorValidationSchema = Yup.object().shape({
  [ConnectorsFieldName.name]: Yup.string().trim().required(i18n.t('validation.required')),

  [ConnectorsFieldName.connectionType]: Yup.mixed<ConnectionType>()
    .oneOf(Object.values(ConnectionType))
    .required(i18n.t('validation.required')),

  [ConnectorsFieldName.enabled]: Yup.boolean().required(),
});
